

export const ClientImages = {
    Logo: 'assets/images/client/clientLogo.png',
    LogoHorizontal: 'assets/images/client/clientLogoHorizontal.png',
    LogoHorizontalWhite: 'assets/images/client/clientLogoHorizontalWhite.png',
    Icon: 'assets/images/client/clientIcon.png',
    FavIcon: 'assets/images/client/clientFavIcon.png'
}